// native-federation:build が出力するエントリは es-module-shims 前提（type="module-shim"）。
// host 自身の共有依存(@angular/* など)の import map を initFederation() で用意してから
// bootstrap する。これを呼ばないと es-module-shims が '@angular/platform-browser' 等を
// 解決できず、host アプリ自体が起動しない（app-root が空のまま）。
// React/Vite remote は RemoteOutlet 内で @module-federation/runtime によりロードする。
import { initFederation } from "@angular-architects/native-federation";

initFederation()
  .catch((err) => console.error(err))
  .then(() => import("./bootstrap"))
  .catch((err) => console.error(err));
